const WORDS_PER_PAGE_SINGLE_SPACING = 500;
export const getWordsPerPage = (spacing: number): number => (
  Math.ceil(WORDS_PER_PAGE_SINGLE_SPACING / spacing)
);

export const getTotalWords = (spacing: number, numberOfPages: number): number => (
  Math.ceil(getWordsPerPage(spacing) * numberOfPages)
);
